/**
 * Controle de acesso por usuário/sistema (lado do Portal).
 *
 * Cada usuário tem uma lista de sistemas que pode acessar (`user.sistemas`).
 * O Admin Supremo abaixo IGNORA a lista — vê e acessa todos os sistemas, com
 * todas as funções. É o único login global. (O backend espelha esta regra.)
 */
export const ADMIN_SUPREMO_LOGIN = "admin@portalsercamp.com";

/** É o Admin Supremo? (comparação por login, sem diferenciar maiúsc./minúsc.) */
export function isAdminSupremo(usuario: string | null | undefined): boolean {
  return (usuario ?? "").trim().toLowerCase() === ADMIN_SUPREMO_LOGIN;
}

/**
 * Admin Cybersecurity: login único, SOMENTE LEITURA, que enxerga apenas o
 * painel central de auditoria/segurança (ver CybersegDashboard.tsx e
 * server/security-audit.ts) — não acessa nenhum sistema, não tem função de
 * escrita em lugar nenhum. Ao contrário do Admin Supremo, este login NÃO é
 * reconhecido dentro dos outros 10 sistemas.
 */
export const ADMIN_CYBER_LOGIN = "admin@cyber.com";
export function isAdminCyberseg(usuario: string | null | undefined): boolean {
  return (usuario ?? "").trim().toLowerCase() === ADMIN_CYBER_LOGIN;
}
